import React from 'react';
import { useSorting } from '@atlassian/jira-business-filters/src/services/sorting/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type SortingIndicatorType from './main.tsx';
import type { SortingIndicatorProps } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazySortingIndicator = lazyAfterPaint<typeof SortingIndicatorType>(
	() => import(/* webpackChunkName: "async-jwm-common-sorting-indicator" */ './main'),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: SortingIndicatorProps) => {
	const [sorting] = useSorting();

	return (
		<Placeholder name="sorting-indicator" fallback={null}>
			{(props.columnName === sorting.sortBy || props.isVisible) && (
				<LazySortingIndicator {...props} />
			)}
		</Placeholder>
	);
};
